module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/creditos/components/pagos-distribucion/components/agregar-pago/agregar-pago-dist.component.scss
// module id = ./src/app/creditos/components/pagos-distribucion/components/agregar-pago/agregar-pago-dist.component.scss
// module chunks = main